<div class="greeting-task-area">
      <!-- <app-ui-loader [autoRemove]="0" text="Metamorphing..." icon="butterfly"  [showLoader]="loadCasesSummaryPanel">
    </app-ui-loader> -->
  <div class="head-section">
    <h2 class="dashboard-head">{{'Workbench' | MMSTranslate}}</h2>
    <div>
      <button nz-button [nzType]="'primary'" (click)="openOrgHierarchyModal()">
        <i nz-icon nzType="apartment" nzTheme="outline"></i>{{'Organization Hierarchy' | MMSTranslate}}
      </button>
    </div>
  </div>
  <div class="grid grid-40-auto" style="padding-bottom: 15px;">
    <div>
      <div class="dashboard-head-sub">
        <nz-avatar class="greet-avatar" [nzSrc]="'/assets/images/ico/'+timeOfDay+'.png'" nzSize="small" nzIcon="user">
        </nz-avatar>
        <strong class="p-l-10 p-r-5 d-i-b">{{'Good' | MMSTranslate}} {{timeOfDay}}, <span>{{userName}}!</span>&nbsp;
          <!-- <span *ngIf="userRole?.roleId">({{userRole?.roleId | technicalTranslate}})</span>! -->
        </strong>
        {{"Here's a quick summary of key data points" | MMSTranslate}}
      </div>

      <div class="grid grid-3x grid-gap-20 workbench-task-count-sec m-t-5">
        <div *ngFor="let taskItems of workbenchTaskCards" [style.background]="taskItems.bgColor"
          class="workbench-task-count-card">
          <nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true"
            [nzLoading]="(taskItems.key == 'individual' && isLoading) || (taskItems.key == 'team' && teamDataNotReceived) || (taskItems.key == 'subordinate' && subordinateDataNotReceived)">
            <div class="workbench-task-count-img-sec workbench-task-count-card">
              <div class="workbench-task-count-img"> <img [src]="taskItems.img" alt="" /></div>
              <div class="text-a-center"><span class="workbench-task-count">{{taskItems.count}}</span></div>
            </div>
            <div class="workbench-task-count-label text-a-center f-w-500">{{taskItems.label | MMSTranslate}}</div>
          </nz-skeleton>
        </div>
      </div>
    </div>
    <!--  -->
     <div class="assigned-imp-task-list-area" *ngIf="!loadCasesSummaryPanel">
      <h5 class="imp-task-heading">{{'Important cases and activities for today' | MMSTranslate}}</h5>
      <ng-container>
       <!--  Removed workQueueAPIResponse condition since we need to show header data of logged in user, irrespective of tab he is selecting to view cases -->
        <!-- <ng-container *ngIf="(workQueueAPIResponse && workQueueAPIResponse.length); else showNoTask;"> -->
        <nz-timeline>
          <nz-timeline-item>{{'You have total' | MMSTranslate}}<span class="f-w-600"> {{ impTaskCount['totalCases'] || this.workQueueAPIResponse.length }} {{'cases' | MMSTranslate}}</span>
            {{'assigned to you' | MMSTranslate}}</nz-timeline-item>
          <nz-timeline-item>
            <span *ngIf=" impTaskCount && impTaskCount['SLATaskCount'];else showNoSLACases">
              <span *ngIf="impTaskCount['SLATaskCount'] == 1"><span class="f-w-600">{{impTaskCount['SLATaskCount']}} {{'case' | MMSTranslate}}</span> {{'might breach ' | MMSTranslate}}</span>
              <span *ngIf="impTaskCount['SLATaskCount'] > 1"><span class="f-w-600">{{impTaskCount['SLATaskCount']}} {{'cases' | MMSTranslate}}</span> {{'might breach ' | MMSTranslate}}</span>
              <nz-tag [nzColor]="'orange'"> {{'SLA' | MMSTranslate}}</nz-tag>
              <!-- <i class="summary-icons">🕑</i> -->
            </span>
            <span *ngIf="impTaskCount && impTaskCount['missedSLATaskCount'];">
              <span *ngIf="impTaskCount['missedSLATaskCount'] == 1"><span class="f-w-600">{{impTaskCount['missedSLATaskCount']}} {{'cases' | MMSTranslate}} </span> {{'has breached' | MMSTranslate}}
                <nz-tag [nzColor]="'red'"> {{'SLA' | MMSTranslate}}</nz-tag>
                <!-- <i class="summary-icons">⌛🚨</i> -->
              </span>
              <span *ngIf="impTaskCount['missedSLATaskCount'] > 1">
                <span class="f-w-600">{{impTaskCount['missedSLATaskCount']}} {{'cases' | MMSTranslate}}</span> {{'have breached' | MMSTranslate}}
                <nz-tag [nzColor]="'red'"> {{'SLA' | MMSTranslate}} </nz-tag>
                <!-- <i class="summary-icons">⌛🚨</i> -->
              </span>
            </span>
          </nz-timeline-item>
          
          <nz-timeline-item>
            <span *ngIf="impTaskCount && impTaskCount['complexTaskCount'];else showNoComplexCases">
              <span *ngIf="impTaskCount['complexTaskCount'] == 1">
                <span class="f-w-600">{{impTaskCount['complexTaskCount']}} {{'case' | MMSTranslate}}</span> is <nz-tag [nzColor]="'red'">{{'High Complexity' | MMSTranslate}}</nz-tag>
                <!-- <i class="summary-icons">🧐</i>  -->
              </span>
              <span *ngIf="impTaskCount['complexTaskCount'] > 1">
                <span class="f-w-600">{{impTaskCount['complexTaskCount']}} {{'cases' | MMSTranslate}}</span> are <nz-tag [nzColor]="'red'">{{'High Complexity' | MMSTranslate}}</nz-tag>
                <!-- <i class="summary-icons">🧐</i> -->
              </span>
            </span>
          </nz-timeline-item>
          <nz-timeline-item>
            <span *ngIf="impTaskCount && impTaskCount['priorityTaskCount'];else showNoPriorityCases">
              <span *ngIf="impTaskCount['priorityTaskCount'] == 1">
                <span class="f-w-600">{{impTaskCount['priorityTaskCount']}} {{'case' | MMSTranslate}}</span> {{'is on' | MMSTranslate}} 
                <nz-tag [nzColor]="'red'">{{'High Priority' | MMSTranslate}}</nz-tag>
              </span>
              <span *ngIf="impTaskCount['priorityTaskCount'] > 1">
                <span class="f-w-600">{{impTaskCount['priorityTaskCount']}} {{'cases' | MMSTranslate}}</span> {{'are on' | MMSTranslate}} 
                <nz-tag [nzColor]="'red'">{{'High Priority' | MMSTranslate}}</nz-tag>
              </span>
            </span>
          </nz-timeline-item> 
        </nz-timeline>

      </ng-container>
    </div>
    <!-- <i class="summary-icons">🙂</i> -->
    <ng-template #showNoTask>
      <div style="line-height: 36px;">You have no cases assigned to you</div>
    </ng-template>
    <ng-template #showNoSLACases>
      0 cases might breach <nz-tag [nzColor]="'orange'">SLA</nz-tag>
    </ng-template>
    <ng-template #showNoComplexCases>
      You have no <nz-tag [nzColor]="'green'">complex cases</nz-tag>assigned to you
    </ng-template>
    <ng-template #showNoPriorityCases>
      No cases are assigned with <nz-tag [nzColor]="'green'">High Priority</nz-tag>
    </ng-template> 
    <!--  -->
  </div>
</div>

<div class="m-b-10">
  <div class="flexie-auto-grid">
    <!-- Search -->
    <div>
      <div>
        <!-- <h3 translate>{{'Search' | MMSTranslate}}</h3> -->
        <app-ui-search [(SearchCriteria)]="CRITERIALOOKUP" (componentOutput)="fetchSearchResult($event)"
          searchURL="searchInbox" itemsPerPage='20' [(inboxViewName)]="inboxViewName">
        </app-ui-search>
      </div>
    </div>
    <!-- Inbox Type Switcher: My/Subordinate/Team -->
    <div class="text-a-right">
      <!-- <h3>Inbox</h3> -->
      <nz-radio-group *ngIf="inboxFullPrivilege" [(ngModel)]="radioValue" [nzButtonStyle]="'solid'"
        [nzSize]="'default'" [nzDisabled]="disableCasesToggle" (ngModelChange)="onChangeOfTaskType($event)">
        <label nz-radio-button nzValue="myCases" (click)="loadCases('myCases');getCaseCategory('myCases')" translate>
          <i nz-icon nzType="user" nzTheme="outline" style="font-size: 13px;"></i> {{'My Cases' | MMSTranslate}}</label>
        <label nz-radio-button nzValue="teamCases" (click)="loadCases('teamCases');getCaseCategory('teamCases')" translate>
          <i nz-icon nzType="team" nzTheme="outline"></i>{{'Reportee Cases' | MMSTranslate}}</label>
        <label nz-radio-button nzValue="subCases" (click)="loadCases('subCases');getCaseCategory('subCases')">
          <i nz-icon nzType="usergroup-add" nzTheme="outline"></i> {{'Work Manager Cases' | MMSTranslate}}</label>
      </nz-radio-group>
      <!-- <button style="margin-left:10px" nz-button nz-dropdown [nzDropdownMenu]="inbox" nzPlacement="bottomRight">
        <span nz-icon nzType="ellipsis"></span>
      </button>
      <nz-dropdown-menu #inbox="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item >Select Task</li>
          <li nz-menu-item >Refresh Data</li>
        </ul>
      </nz-dropdown-menu> -->
    </div>
  </div>
</div>
<div class="inbox-grid">
  <!--Menu Items Block -->
  <div class="inbox-tree">
    <button *ngIf="enableViewAllCases" id="viewAll" nz-button [nzType]="'default'" (click)="viewAllCases()"><i
      nz-icon nzType="" nzTheme="outline"></i> View All</button>
    <!-- Tree Block -->
    <h3 class="m-l-10" *ngIf="radioValue != 'teamCases'">Work Queues</h3>
    <nz-tree [nzData]="nodes" nzShowIcon="true" (nzClick)="treeClick($event)"></nz-tree>

    <!-- Reassign Block -->
    <!-- <div>
      <h5>Reassign Tasks</h5>
      <span class="col-grey d-b">Select tasks to re-assign them</span>
      <a class="d-b" (click)="assingTask()">Reassign selected tasks</a>
    </div> -->

  </div>

  <!-- Items / Inbox Cards Block -->
  <div style="overflow: auto;">

    <!-- new block -->
    <div class="flex task-options-bar flex-horiz-space-bw">
      <div *ngIf="selectedTaskRequired" class="content-left">
        <span class="col-grey-dark">
          Selected Task Options
          &nbsp;({{numberOfChecked?numberOfChecked:'None'}} selected)
        </span>
        <nz-divider nzType="vertical"></nz-divider>
        <label nz-checkbox name="checkall" [(ngModel)]="allChecked" (ngModelChange)="updateAllChecked()"
          [nzIndeterminate]="indeterminate">
          Select all
        </label>
      </div>
      <div class="content-left">
        <span *ngIf="taskList && taskList.length > 0" class="col-grey-dark">
          <span class="f-w-700">({{taskList.length}})</span>&nbsp;Task Selected 
        </span>
      </div>
      <div class="content-right flex">
        <!-- Sorting Need To fix here-->
        <div>
          <div class="d-i-b" *ngIf="sortTaskRequired && workTaskFetched">
            <nz-select *ngIf="dataView!='grid-layout'" class="dd-sort" nzSize="default" [(ngModel)]="fieldSelectedFilter">
              <ng-container *ngFor="let attribute of sortFields">
                <nz-option [nzLabel]="attribute.description" [nzValue]="attribute.dataKey"></nz-option>
              </ng-container>
            </nz-select>
            <button *ngIf="dataView!='grid-layout'"  id="ascending" nz-button [nzType]="isAscendingSort?'primary' : 'default'" (click)="sortInAscending()"><i nz-icon
                nzType="sort-ascending" nzTheme="outline"></i></button>
            <div *ngIf="dataView!='grid-layout'" class="dd-btn-separator"></div>
            <button *ngIf="dataView!='grid-layout'" id="descending" nz-button [nzType]="isDescendingSort?'primary' : 'default'" (click)="sortInDescending()"><i
                nz-icon nzType="sort-descending" nzTheme="outline"></i></button>
            <div *ngIf="dataView!='grid-layout'" class="dd-btn-separator"></div>
            <nz-divider *ngIf="dataView!='grid-layout'" nzType="vertical"></nz-divider>
          </div>
          <!-- <nz-select class="dd-sort" nzSize="default" [(ngModel)]="fieldSelectedFilter">
            <ng-container *ngFor="let attribute of filteredMetaDataMap">
              <nz-option [nzLabel]="attribute.description" [nzValue]="attribute.key"></nz-option>
            </ng-container>
          </nz-select>
          <button id="ascending" nz-button [nzType]="isAscendingSort?'primary' : 'default'" (click)="sortInAscending()"><i nz-icon
              nzType="sort-ascending" nzTheme="outline"></i></button>
          <div class="dd-btn-separator"></div>
          <button id="descending" nz-button [nzType]="isDescendingSort?'primary' : 'default'" (click)="sortInDescending()"><i
              nz-icon nzType="sort-descending" nzTheme="outline"></i></button>
          <div class="dd-btn-separator"></div>
          <nz-divider nzType="vertical"></nz-divider> -->
          <button id="cards-layout" nz-button (click)="setDataView('cards-layout')"><i nz-icon
              nzType="bars" nzTheme="outline"></i></button>
          <div class="dd-btn-separator"></div>
          <button id="grid-layout" nz-button (click)="setDataView('grid-layout')"><i
              nz-icon nzType="table" nzTheme="outline"></i></button>
          <div class="dd-btn-separator"></div>
          <nz-divider nzType="vertical"></nz-divider>
        </div>
        <!-- Buttons-->
        <!-- <div *ngIf="taskOperationButtonRequired"> -->
          <!-- <button *ngIf="inboxFullPrivilege" nz-button nzType="default" [disabled]="taskList.length <= 0">
            Freeze
          </button>
          <nz-divider nzType="vertical"></nz-divider> -->
          <!-- <button id="reAssign" *ngIf="inboxFullPrivilege" nz-button nzType="primary" [disabled]="taskList.length <= 0" (click)="showAssignModal()">
            Re-Assign
          </button> -->
          <!-- <div class="btn-align" style="width: 100%;text-align: end;margin-bottom: 10px"> "-->
            <button *ngIf="inboxFullPrivilege" nz-button [nzType]="'primary'" [disabled]="taskList.length <= 0" (click)="showAssignModal()">
              <i nz-icon nzType="user" theme="outline"></i><span style="margin-left: 5px;">Reassign</span></button>
            <nz-divider nzType="vertical" style="margin-top: 10px !important;"></nz-divider>
            <button *ngIf="inboxFullPrivilege" nz-button (click)="inboxConfiguration()" [nzType]="'primary'">
              <!-- <img src="assets\outline\personalized inbox.svg" alt="PersonalizedInbox" width="20px" height="20px"> -->
              <span nz-icon nzType="setting" nzTheme="outline"></span>
              <span style="margin-left: 5px;">Personalized Inbox</span>
            </button>
            <nz-divider *ngIf="inboxFullPrivilege && personalizedInboxUserJSON" nzType="vertical" style="margin-top: 10px !important;"></nz-divider>
          <button nz-button nzType="primary" nz-tooltip nzTooltipTitle="Export data" (click)="createTemplateExcel()"><i nz-icon nzType="download"></i></button>
          <!-- </div> -->
        <!-- </div> -->
      </div>
    </div>
    <!-- new block End -->

    <div>
      <nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="isLoading || subordinateDataNotReceived || teamDataNotReceived">
      <ng-container *ngIf="dataView=='cards-layout' && refreshInboxToggle">
        <div nz-row
          *ngFor="let workQueueItem of (getPageWiseInboxItems(workQueueAPIResponse | SortTaskList: sortCriteria) | async); index as i;">
          <app-inbox-card (componentOutput)="openTransactionDetails($event)" [InboxType]="_inboxType" style="width: 100%;"
            [inputDataInboxCard]="workQueueItem" [filteredMetaDataMap]="
              (personalizedInboxUserJSON[workQueueItem.serviceTask] && personalizedInboxUserJSON[workQueueItem.serviceTask]['dataPoints'] && personalizedInboxUserJSON[workQueueItem.serviceTask]['dataPoints'].length) 
              ? personalizedInboxUserJSON[workQueueItem.serviceTask]['dataPoints'] 
              : (personalizedInboxroleCdJson[workQueueItem.serviceTask] && personalizedInboxroleCdJson[workQueueItem.serviceTask]['dataPoints'] && personalizedInboxroleCdJson[workQueueItem.serviceTask]['dataPoints'].length)
                        ? personalizedInboxroleCdJson[workQueueItem.serviceTask]['dataPoints'] 
                        : filteredMetaDataMap" [currentUserId]="currentUser">
          </app-inbox-card>
        </div>
      </ng-container>
      <div *ngIf="dataView=='grid-layout'  && refreshInboxToggle" style="margin-bottom: 20px;">
        <div style="overflow-x: auto; width: 100%;">
          <nz-table #workbenchTable nzShowPagination="false" [nzData]="workQueueAPIResponse" nzSize="small">
            <thead (nzSortChange)="sort($event)" nzSingleSort>
              <tr>
                <th nzWidth="50px" nzLeft="0px">Select</th>
                <ng-container *ngFor="let column of filteredMetaDataMap; index as workqueueHeaderItemIndex">
                  <ng-container *ngIf="column.isVisible">
                  <th nzWidth="120px" *ngIf="(!column.searchFilter && !column.sortFilter)">
                    {{column.description}}</th>
                  <th nzWidth="150px" *ngIf="(column.searchFilter && column.sortFilter)" nzCustomFilter nzShowSort
                    [nzSortKey]="column.key">
                    {{column.description}}
                    <i nz-th-extra class="ant-table-filter-icon" nz-icon nz-dropdown #dropdown="nzDropdown" nzType="search"
                      [nzDropdownMenu]="menu" [class.ant-table-filter-open]="dropdown.nzVisible" nzTrigger="click"
                      nzPlacement="bottomRight" [nzClickHide]="false" nzTableFilter (click)="getConfigKey(column.key)"></i>
                  </th>
                  <th nzWidth="150px" *ngIf="(column.searchFilter && !column.sortFilter)" nzCustomFilter>
                    {{column.description}}
                    <i nz-th-extra class="ant-table-filter-icon" nz-icon nz-dropdown #dropdown="nzDropdown" nzType="search"
                      [nzDropdownMenu]="menu" [class.ant-table-filter-open]="dropdown.nzVisible" nzTrigger="click"
                      nzPlacement="bottomRight" [nzClickHide]="false" nzTableFilter (click)="getConfigKey(column.key)"></i>
                  </th>
                  <th nzWidth="150px" *ngIf="(!column.searchFilter && column.sortFilter)" nzShowSort [nzSortKey]="column.key">
                    {{column.description}}</th>
                  </ng-container>
                </ng-container>
                <th nzWidth="250px"> Claim / Intimation No </th>
                <th nzWidth="100px"> Product </th>
                <th nzWidth="200px"> SLA </th>
                <th nzWidth="50px"> Complexity </th>
                <th nzWidth="100px"> Priority </th>
                <th nzWidth="150px"> Created Date </th>
                <th nzWidth="100px"> Last Re-assigned By </th>
                <th nzWidth="100px"> Assigned To </th>
                <th scope="col" nzRight="0px" nzAlign="center" [nzWidth]="'130px'" class="text-a-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of (getPageWiseInboxItems(workbenchTable | SortTaskList: sortCriteria) | async)">
                <!-- <td>
                          <label *ngIf="inboxFullPrivilege" nz-checkbox [(ngModel)]="data['selected']"
                            nzValue="data.id" (ngModelChange)="emitSelectedTask($event,workQueueItem)">
                            {{workQueueItem.serviceTask == 'CLAIM_INTIMATION' || workQueueItem.serviceTask == 'CLAIM_BRANCH_INTIMATION'? workQueueItem.intimationNum : workQueueItem.claimNum}}
                          </label>
                        </td> -->
      
                <td>
                  <label *ngIf="inboxFullPrivilege" nz-checkbox [(ngModel)]="data['isSelected']" nzValue="data.id"
                    (ngModelChange)="emitSelectedTask($event,data)">
                  </label>
                </td>
      
                <ng-container *ngFor="let inboxConfig of filteredMetaDataMap;let index = workqueueDataItemIndex">
                  <ng-container *ngIf="inboxConfig.isVisible">
                  <td [ngClass]="inboxConfig.textEllipsis ? 'text-ellipsis' : 'break-word'">
                    <span
                      *ngIf="!inboxConfig.pipe && inboxConfig.key!='earlyClaimFl' && inboxConfig.key!='commencementDt' && inboxConfig.key!='policyAgeInDays'">{{data[inboxConfig.key]}}</span>
                    <span *ngIf="inboxConfig.pipe && (inboxConfig.pipe == 'technicalTranslate')">{{(data[inboxConfig.key] |
                      technicalTranslate)}}</span>
                    <span
                      *ngIf="inboxConfig.pipe && (inboxConfig.pipe == 'technicalTranslate' && inboxConfig.pipeValue)">{{(data[inboxConfig.key]
                      | technicalTranslate: inboxConfig.pipeValue)}}</span>
                    <span *ngIf="data[inboxConfig.key] && inboxConfig.pipe && inboxConfig.pipe == 'date'">{{(data[inboxConfig.key]
                      |
                      date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR)}}</span>
                    <span
                      *ngIf="data[inboxConfig.key] && inboxConfig.pipe && inboxConfig.pipe == 'CurrencyFormatter'">{{(data[inboxConfig.key]
                      | CurrencyFormatter)}}</span>
                    <span *ngIf="inboxConfig.key=='earlyClaimFl'" [class.highlight]="inboxConfig.isSelected">
                      {{getEarlyNonEarlyString(data[inboxConfig.key]?data[inboxConfig.key] : "-") | async}}
                    </span>
                    <!-- <span *ngIf="inboxConfig.key=='commencementDt'" [class.highlight]="inboxConfig.isSelected">
                                            {{getDateString(data[inboxConfig.key]?data[inboxConfig.key] : "-")}}
                                          </span> -->
                    <span *ngIf="inboxConfig.key=='policyAgeInDays'" [class.highlight]="inboxConfig.isSelected">
                      {{getDaysInYear(data[inboxConfig.key]?data[inboxConfig.key] : 0 ) | async }}
                    </span>
                    <span *ngIf="!data[inboxConfig.key] && inboxConfig.key!='earlyClaimFl'">-</span>
                  </td>
                  </ng-container>
                </ng-container>
                <!-- <td (click)="openTransactionDetails(data,'grid-layout')">
                      <a class="cur-pointer">Open</a>
                    </td> -->
      
                <td>
                  <span class="m-r-20">{{data.serviceTask == 'CLAIM_INTIMATION' || data.serviceTask ==
                    'CLAIM_BRANCH_INTIMATION'? data.intimationNum : data.claimNum}}</span>
                  <nz-tag *ngIf="data.eventTypeCd" class="pointer-pass-thru" [nzColor]="'blue'">{{data.eventTypeCd|| ''
                    |translate }}</nz-tag>
                </td>
                <td>
                  <span>
                    {{(data.baseProductCd | technicalTranslate:'productId') || '-'}}</span>
                </td>
                <td>
                  <span *ngIf="inboxFullPrivilege" class="d-b w-100-pc-force"
                    [nzColor]="data.level == 'LEVEL4' ? 'red' : data.level == 'LEVEL3' ? 'red' : data.level == 'LEVEL2' ? 'orange' : 'green'">{{(data?.levelEndTime
                    | date:'medium') || '-'}}</span>
                </td>
                <td>
                  <span *ngIf="inboxFullPrivilege" class="d-b w-100-pc"
                    [nzColor]="(data.complexityScore > 7) ? 'red' : (data.complexityScore > 3) ? 'orange' : 'green'">{{data.complexityScore
                    || '-'}}</span>
                </td>
                <td>
                  <span *ngIf="inboxFullPrivilege" class="d-b w-100-pc"
                    [nzColor]="(data.priority == 'HIGH'|| data.priority == 'High' || data.priority ==  'high') ? 'red' : (data.priority == 'MEDIUM' || data.priority == 'Medium' || data.priority == 'medium') ? 'orange' : 'green'">{{data.priority
                    || '-' |translate }}
                  </span>
                </td>
                <td>
                  <span>{{getDateString(data.startDt) || '' }}</span>
                </td>
                <td>
                  <span>{{(data.lastReassignedBy? (data.lastReassignedBy | translate): '-' )}}</span>
                </td>
                <td>
                  <span>{{(data.taskUser ? (data.taskUser | translate) : '-' )}}</span>
                </td>
      
                <td nzRight="0px" nzAlign="center" class="text-a-center">
                  <a nz-dropdown [nzDropdownMenu]="menu">Actions
                    <i nz-icon nzType="down"></i>
                  </a>
                  <nz-dropdown-menu #menu="nzDropdownMenu">
                    <ul nz-menu nzSelectable>
                      <li nz-menu-item (click)="openTransactionDetails(data,'grid-layout')">Open</li>
                      <li nz-menu-item (click)="openAnalyzeModal(1,data)"> Analyze</li>
                      <li nz-menu-item (click)="openActivityModal(1,data)">Activity Timeline</li>
                    </ul>
                  </nz-dropdown-menu>
                </td>
              </tr>
            </tbody>
          </nz-table>
      
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <div class="ant-table-filter-dropdown">
              <div class="search-box">
                <input type="text" nz-input [(ngModel)]="searchValue" />
                <button nz-button nzSize="small" nzType="primary" (click)="search(searchValue)" class="search-button">
                  Search
                </button>
                <button nz-button nzSize="small" (click)="loadCases('myCases')">Reset</button>
              </div>
            </div>
      
            <!---Older Version of ng-zorro (8.x)--->
      
          </nz-dropdown-menu>
        </div>
      </div>
      </nz-skeleton>
    </div>
   

    <app-generic-zero-ui *ngIf="!isLoading && sortCriteria"
      [list]="(workQueueAPIResponse | SortTaskList: sortCriteria)"></app-generic-zero-ui>

    <app-generic-zero-ui *ngIf="!isLoading && !sortCriteria" [list]="workQueueAPIResponse"></app-generic-zero-ui>
    <ng-container *ngIf="isLoading">
      <div *ngFor="let item of fakeLoadingCards" nz-col nzSpan="24" class="task-item shadowed-on-hover">
        <nz-skeleton *ngFor="let item of fakeLoadingCards" [nzAvatar]="false" [nzActive]="true" [nzTitle]="true"
          [nzLoading]="isLoading"></nz-skeleton>
      </div>
    </ng-container>
  </div>
</div>
<div *ngIf="appMetadataHandler.featureFlags.enablePaginationOnInbox" class="pagination-inbox text-a-center">
  <nz-pagination [nzPageIndex]="pageNumber" [nzTotal]="totalitems" nzShowSizeChanger [nzPageSize]="itemsPerPage"
    (nzPageIndexChange)="setCurrentPageNumber($event)" (nzPageSizeChange)="setItemsPerPage($event)"></nz-pagination>
</div>

<!-- <pre *ngIf="!env.production">$Dev Mode Logs: 
  Page Number: {{pageNumber}}
  Data Log: {{(getPageWiseInboxItems(workQueueAPIResponse) | async)|json}}$</pre> -->


<!-- Analytics -->

<nz-modal [(nzVisible)]="analyticsModal" nzTitle="Analyze" (nzOnCancel)="analyticsModal=false"
  (nzOnOk)="analyticsModal=false" nzOkText="Ok" nzWidth="820px" nzZIndex="100">
  <ng-container *nzModalContent>
    <div *ngIf="analyticsModal">
      <app-ui-analytics-tab mode="tab" [workQueueItem]="analyticsWorkQueueItemData"></app-ui-analytics-tab>
    </div>
  </ng-container>
</nz-modal>

<!-- Activity Timeline -->

<nz-modal [(nzVisible)]="activityModal" nzTitle="Activity Timeline" (nzOnCancel)="activityModal=false"
  (nzOnOk)="activityModal=false" nzOkText="Ok" nzWidth="820px" nzZIndex="100">
  <ng-container *nzModalContent>
    <div *ngIf="activityModal">
      <app-claims-activity-timeline mode="tab" [IO]="activityWorkQueueItemData"></app-claims-activity-timeline>
    </div>
  </ng-container>
</nz-modal>

<!-- ReAssign component -->


<nz-modal [(nzVisible)]="modShowReassign" nzTitle="Reassign Tasks" (nzOnCancel)="modShowReassign=false"
  [nzFooter]="null" nzWidth="600px" [nzContent]="reassignTaskContent">
  <ng-template #reassignTaskContent>
    <app-reassign-task [tasksList]="taskList"  (closeModal)="modShowReassign = false"></app-reassign-task>
  </ng-template>
</nz-modal>


<nz-modal [(nzVisible)]="inboxConfigModal" nzTitle="Configure your personalised inbox view" (nzOnCancel)="inboxConfigModal=false"
  (nzOnOk)="inboxConfigModal=false;reloadInbox();" nzOkText="{{'Save' | MMSTranslate}}" nzWidth="900px">
  <ng-container *nzModalContent>
    <!-- <h3 class="heading">{{'Configure Inbox View' | MMSTranslate}}</h3> -->
    <div class="grid grid-2x grid-gap-20 personalizedInboxCardSec">
      <div class="example-container">
        <div class="flex flex-horiz-space-bw">
          <h3 class="heading">Available Data</h3>
          <button nz-button nzSize="small" (click)="selectAllAttributes()"><i nz-icon nzType="export"
              nzTheme="outline"></i>
            <span>Select All</span>
          </button>
        </div>
  
        <div class="example-list">
          <div *ngFor="let item of inboxDataPointsSuperSet" class="example-box" [dndType]="'item'"
            (dndMoved)="removeItem(item, inboxDataPointsSuperSet)" [dndDraggable] [dndObject]="item">
            {{item.description}}
          </div>
        </div>
  
        <!-- <div
          cdkDropList
          #superSet="cdkDropList"
          [cdkDropListData]="inboxDataPointsSuperSet"
          [cdkDropListConnectedTo]="[defaultSet]"
          class="example-list"
          (cdkDropListDropped)="drop($event)">
          <div class="example-box" *ngFor="let item of inboxDataPointsSuperSet" cdkDrag>
            {{item.description}}</div>
        </div> -->
      </div>
  
      <div class="example-container">
        <h3 class="heading">Selected Data</h3>
  
        <div class="example-list">
          <div *ngFor="let item of inboxDataPointsDefaultSet" class="example-box" [dndType]="'item'"
          (dndMoved)="removeItem(item, inboxDataPointsDefaultSet)" [dndDraggable] [dndObject]="item">
            <div>
              <label nz-checkbox [(ngModel)]="item.isSelected" nz-tooltip
                nzTooltipTitle="Highlight this data on the inbox"
                (ngModelChange)="inboxDataSelected($event)">{{item.description}}</label>
            </div>
          </div>
        </div>
  
        <!-- <div class="example-list" dnd-droppable (onDropSuccess)="onTargetDrop($event)">
          <div class="example-box" *ngFor="let item of inboxDataPointsDefaultSet; let i = index; let last = last" dnd-draggable [dragData]="item">
            <div>
              <label nz-checkbox [(ngModel)]="item.isSelected" nz-tooltip nzTooltipTitle="Highlight this data on the inbox" (ngModelChange)="inboxDataSelected($event)">{{item.description}}</label>
            </div>
          </div>
        </div> -->
  
        <!-- <div
          cdkDropList
          #defaultSet="cdkDropList"
          [cdkDropListData]="inboxDataPointsDefaultSet"
          [cdkDropListConnectedTo]="[superSet]"
          class="example-list"
          (cdkDropListDropped)="drop($event)">
          <div class="example-box" *ngFor="let item of inboxDataPointsDefaultSet; let i = index; let last = last" cdkDrag>
            <div>
              <label nz-checkbox [(ngModel)]="item.isSelected" nz-tooltip nzTooltipTitle="Highlight this data on the inbox" (ngModelChange)="inboxDataSelected($event)">{{item.description}}</label>
            </div>
            <div>
              <a *ngIf="i>0" class="mutates-data col-grey-dark" nz-popconfirm [nzPopconfirmTitle]="'Move Up'" nzOkText="Move Up"
                nzCancelText="Cancel"  nz-tooltip nzTooltipTitle="Move Up" (nzOnConfirm)="moveAttributeUpOrDown(i,'UP')">
                <i nz-icon nzType="caret-up" nzTheme="outline"></i>
              </a>
              <nz-divider *ngIf="i>0 && !last" nzType="vertical"></nz-divider>
              <a *ngIf="!last" class="mutates-data col-grey-dark" nz-popconfirm [nzPopconfirmTitle]="'Move Down'" nzOkText="Move Down"
                nzCancelText="Cancel" nz-tooltip nzTooltipTitle="Move Down" (nzOnConfirm)="moveAttributeUpOrDown(i,'DOWN')">
                <i nz-icon nzType="caret-down" nzTheme="outline"></i>
              </a>
            </div>
          </div>
        </div> -->
      </div>
  
    </div>
  </ng-container>
</nz-modal>

<!-- Org hierarchy component -->
<nz-modal [(nzVisible)]="showOrgHierarchy" nzTitle="Organization Hierarchy" (nzOnCancel)="showOrgHierarchy=false"
  nzCancelText="Close"  [nzOkText]="null" nzWidth="60vw">
  <ng-container *nzModalContent>
   <app-org-hierarchy></app-org-hierarchy>
  </ng-container>
</nz-modal>

<!-- Personalized inbox view modal -->
<div *ngIf="dataTransformService.enablePersonalizedInboxModal">
  <app-personalized-view (componentOutput)="personalizedFields($event)" [IO]="personalizedInboxUserJSON" [RoleCdSuperSet]="personalizedInboxroleCdJson" [showPersonalizedConfigModal]="true"></app-personalized-view>
  </div>
